if (!customElements.get('chapon-recommendations')) {
  customElements.define('chapon-recommendations', class extends HTMLElement {
    connectedCallback() {
      if (this.loaded || this.hasAttribute('data-loaded')) return;
      this.controller = new AbortController();
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) { this.observer.disconnect(); this.load(); }
        }, { rootMargin: '300px' });
        this.observer.observe(this);
      } else this.load();
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
    async load() {
      try {
        const response = await fetch(this.dataset.url, { signal: this.controller.signal });
        if (!response.ok) throw new Error(`Recommendations HTTP ${response.status}`);
        const document = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = document.querySelector(`chapon-recommendations[data-section="${this.dataset.section}"]`);
        if (!content) throw new Error('Recommendations section missing');
        this.innerHTML = content.innerHTML;
        this.removeAttribute('data-pending');
        this.loaded = true;
      } catch (error) {
        if (error.name === 'AbortError') return;
        console.error(error);
        const notice = document.createElement('p');
        notice.className = 'wrap note';
        notice.setAttribute('role', 'status');
        notice.textContent = this.dataset.error;
        if (this.hasAttribute('data-fallback')) this.append(notice);
        else this.replaceChildren(notice);
        this.removeAttribute('data-pending');
      }
    }
  });
}
